import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import { useStyles } from "components/request-document/components/Commons";
import UploadDucument from "components/request-document/components/UploadDucument";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { REQUEST_DOCUMENT_STEP } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  documentRequiredSlice,
  getDocumentRequired,
} from "redux/modules/visaForm";

export default function UploadDucumentStep() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isSaveDraft, setSaveDraft] = useState(false);

  const { smartserviceId } = useSmartService();
  const { personalId } = usePersonalDetail();
  const { draftId, addSmartFormState, getSmartForm, isTypeChange } =
    useSmartForm();

  const { showLoading, hideLoading } = useModalLoading();

  useEffect(() => {
    if (smartserviceId) {
      dispatch(
        getDocumentRequired({
          smartserviceId,
          ...(isTypeChange && { ConditionType: "CHANGE" }),
        })
      );
      getSmartForm({
        smartserviceId,
        draftId,
        personalId,
      });
    }
  }, [dispatch, draftId, getSmartForm, personalId, smartserviceId]);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      showLoading();
    } else if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        dispatch(documentRequiredSlice.actions.clearAsyncState());

        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.SURVEY));
        } else {
          getSmartForm({
            smartserviceId,
            draftId,
            personalId,
          });
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [addSmartFormState, dispatch, hideLoading, showLoading]);

  return (
    <div className={classes.root}>
      <ContentTitle
        title="Smart Visa “I” ( Investors) )"
        subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “I”"
      />

      <Steper currentStep={2} stepInfo={REQUEST_DOCUMENT_STEP} />
      <UploadDucument setSaveDraft={setSaveDraft} />
    </div>
  );
}
